import { useEffect, useMemo } from 'react';
import { TaxiDriver, TaxiDriverQueryFilterMGT } from '../../../shared/types';
import { isEmpty } from 'lodash';
import { usePageState } from '../../../Hooks/usePageState';
import { useOverviewLinkState } from '../linkstate/RegisterTaxiDriverOverview.linkstate';
import { useGetRegisterTaxiDriverQuery } from '../../../GraphQL/hooks/useGetRegisterTaxiDriverQuery';

export const useSortedRegisterTaxiDriverQuery = () => {
    const { setLoading } = usePageState();
    const [state, setState] = useOverviewLinkState();
    const { page, search, selectedRegisterStatus, selectedAccountStatus, selectedDateRange, pageSize, timestamp } =
        state;

    const request = useMemo(
        () =>
            ({
                search: search ?? '',
                types: isEmpty(selectedRegisterStatus) ? undefined : selectedRegisterStatus,
                accountStatusTypes: isEmpty(selectedAccountStatus) ? undefined : selectedAccountStatus,
                dateRange: selectedDateRange,
                page: page ?? 1,
                limit: pageSize ?? 10,
            }) as TaxiDriverQueryFilterMGT,
        [search, selectedRegisterStatus, selectedAccountStatus, selectedDateRange, pageSize, page]
    );

    useEffect(() => {
        refetch();
    }, [timestamp]);

    const { data: taxiDriverPage, refetch, loading } = useGetRegisterTaxiDriverQuery(request);
    useEffect(() => setLoading(loading), [loading]);

    return {
        sortedRegisterTaxiDrivers: taxiDriverPage?.data ?? [],
        pageCount: taxiDriverPage?.pagination?.pageCount ?? 1,
        totalCount: taxiDriverPage?.pagination?.totalCount ?? 0,
        page: taxiDriverPage?.pagination?.page ?? 1,
        pageSize: pageSize,
        setPage: (newPage: number) => setState({ ...state, page: newPage }),
        setPageSize: (pageSize: number) => setState({ ...state, pageSize: pageSize }),
        refetch: () => refetch({ request }),
        loading,
    };
};
